var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{staticClass:"mb-32",attrs:{"cols":"12"}},[_c('page-content',{attrs:{"title":"Hello! How can we help you?","breadcrumbTitle":true,"breadcrumb":[
        {
          title: 'Pages',
        },
      ]},scopedSlots:_vm._u([{key:"desc",fn:function(){return [_c('p',{staticClass:"h5 mb-0 mt-24 hp-text-color-black-0"},[_vm._v(" or choose a category to quickly find the help you need. ")])]},proxy:true}])})],1),_c('search'),_c('tab-menu',{attrs:{"propsTabIndex":{ index: _vm.index }},on:{"tabMenuChange":_vm.tabMenu}}),_c('tab-content',{attrs:{"propsTabIndex":{ index: _vm.index }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }